import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = {
  key: 1,
  class: "w-full"
}
const _hoisted_3 = {
  key: 2,
  class: "w-full"
}
const _hoisted_4 = {
  key: 3,
  class: "w-full"
}
const _hoisted_5 = {
  key: 4,
  class: "w-full"
}
const _hoisted_6 = {
  key: 5,
  class: "w-full"
}
const _hoisted_7 = {
  key: 6,
  class: "w-full"
}
const _hoisted_8 = {
  key: 7,
  class: "w-full"
}
const _hoisted_9 = {
  key: 8,
  class: "w-full"
}

import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { PersonStores } from '@/store';
import GuardianTable from './components/GuardianTable.vue';
import ClinicianStudentTable from './components/ClinicianStudentTable.vue';
import StudentOrganizationTable from './components/StudentOrganizationTable.vue';
import ClinicianOrganizationTable from './components/ClinicianOrganizationTable.vue';
import ClinicianDisciplines from '@/views/Users/components/Connections/components/ClinicianDisciplines.vue';
import { PEOPLE_TYPES, PERMISSIONS } from '@/enum';
import StudentClinicianTable from './components/StudentClinicianTable.vue';
import StudentFacilitatorTable from '@/views/Users/components/Connections/components/StudentFacilitatorTable.vue';
import SchoolAdminOrganizationTable from '@/views/Users/components/Connections/components/SchoolAdminOrganizationTable.vue';
import ParentStudentTable from '@/views/Users/components/Connections/components/ParentStudentTable.vue';
import FacilitatorOrganizationTable from '@/views/Users/components/Connections/components/FacilitatorOrganizationTable.vue';
import BillingAdminOrganizationTable from '@/views/Users/components/Connections/components/BillingAdminOrganizationTable.vue';
import { useRoute } from 'vue-router';
import { can, usePersonTypes } from '@/composables';
import BuildingsList from './components/Buildings/BuildingsList.vue';
import BuildingsEdit from './components/Buildings/BuildingsEdit.vue';
import Grades from './components/Grades/Grades.vue';
import { useBuildingStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Connections',
  setup(__props) {

const route = useRoute();

onMounted(async () => {
  await refreshConnections();
  await buildingStore.fetchPersonBuildings(userId);
});

const profileStore = PersonStores.useUserProfileStore();
const connectionsStore = PersonStores.useUserConnectionsStore();
const buildingStore = useBuildingStore();
const isModalOpen = ref(false);
const selectedBuilding = ref(null);

const userId = Number(profileStore.userId || route.params.id);

const { organizations, flattenOrganizations, parents, students, clinicians, facilitators, loading } =
  storeToRefs(connectionsStore);

const isClinician = computed(() =>
  usePersonTypes.isClinician(profileStore.person?.people_type?.acronym as PEOPLE_TYPES),
);

const isStudent = computed(() => usePersonTypes.isStudent(profileStore.person?.people_type?.acronym as PEOPLE_TYPES));

const isSchoolAdmin = computed(() =>
  usePersonTypes.isSchoolAdmin(profileStore.person?.people_type?.acronym as PEOPLE_TYPES),
);

const isParent = computed(() => usePersonTypes.isParent(profileStore.person?.people_type?.acronym as PEOPLE_TYPES));

const isFacilitator = computed(() =>
  usePersonTypes.isFacilitator(profileStore.person?.people_type?.acronym as PEOPLE_TYPES),
);

const isBillingAdmin = computed(() =>
  usePersonTypes.isBillingAdmin(profileStore.person?.people_type?.acronym as PEOPLE_TYPES),
);

const refreshConnections = async () => {
  if (can([PERMISSIONS.CONNECTIONS_INDEX])) await connectionsStore.getConnections();
};

const onEditBuilding = async (building) => {
  const loadedOrgId = buildingStore.organizationBuildings[0]?.organization_id;
  if (buildingStore.organizationBuildings.length === 0 || loadedOrgId !== building.organization_id) {
    await buildingStore.fetchOrganizationBuildings(building.organization_id);
  }

  selectedBuilding.value = building;
  isModalOpen.value = true;
};

const handleAttach = async (buildingIdArray: number[]) => {
  await buildingStore.attachPersonBuilding(
    {
      building_ids: buildingIdArray,
    },
    userId,
  );
  isModalOpen.value = false;
  buildingStore.doToast('Building attached successfully');
  await buildingStore.fetchPersonBuildings(userId);
};

const handleDetach = async (buildingIdArray: number[]) => {
  await buildingStore.detachPersonBuilding(
    {
      building_ids: buildingIdArray,
    },
    userId,
  );
  isModalOpen.value = false;
  buildingStore.doToast('Building detached successfully');
  await buildingStore.fetchPersonBuildings(userId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isClinician.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_SHOW]))
            ? (_openBlock(), _createBlock(ClinicianOrganizationTable, {
                key: 0,
                "table-data": _unref(organizations),
                "flat-organizations": _unref(flattenOrganizations),
                "clinician-id": _unref(userId),
                loading: _unref(loading),
                onUpdate: refreshConnections
              }, null, 8, ["table-data", "flat-organizations", "clinician-id", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isStudent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(can)([_unref(PERMISSIONS).STUDENT_ORGANIZATIONS_INDEX]))
            ? (_openBlock(), _createBlock(StudentOrganizationTable, {
                key: 0,
                "table-data": _unref(organizations),
                "student-id": _unref(userId),
                loading: _unref(loading),
                onUpdate: refreshConnections
              }, null, 8, ["table-data", "student-id", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isSchoolAdmin.value && _unref(can)([_unref(PERMISSIONS).SCHOOL_ADMIN_ORGANIZATIONS_INDEX]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SchoolAdminOrganizationTable, {
            "table-data": _unref(organizations),
            "school-admin-id": _unref(userId),
            loading: _unref(loading),
            onUpdate: refreshConnections
          }, null, 8, ["table-data", "school-admin-id", "loading"])
        ]))
      : _createCommentVNode("", true),
    (isParent.value && _unref(can)([_unref(PERMISSIONS).PARENT_STUDENTS_INDEX]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(ParentStudentTable, {
            "table-data": _unref(students),
            "parent-id": _unref(userId),
            loading: _unref(loading),
            onUpdate: refreshConnections
          }, null, 8, ["table-data", "parent-id", "loading"])
        ]))
      : _createCommentVNode("", true),
    (isFacilitator.value && _unref(can)([_unref(PERMISSIONS).FACILITATOR_ORGANIZATIONS_INDEX]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(FacilitatorOrganizationTable, {
            "table-data": _unref(organizations),
            "facilitator-id": _unref(userId),
            loading: _unref(loading),
            onUpdate: refreshConnections
          }, null, 8, ["table-data", "facilitator-id", "loading"])
        ]))
      : _createCommentVNode("", true),
    (isBillingAdmin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(BillingAdminOrganizationTable, {
            "table-data": _unref(organizations),
            "billing-admin-id": _unref(userId),
            loading: _unref(loading),
            onUpdate: refreshConnections
          }, null, 8, ["table-data", "billing-admin-id", "loading"])
        ]))
      : _createCommentVNode("", true),
    (!isParent.value && !isBillingAdmin.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(BuildingsList, {
            "flatten-organizations": _unref(flattenOrganizations),
            buildings: _unref(buildingStore).personBuildings || [],
            "total-records": _unref(buildingStore).totalRecords ?? 0,
            loading: _unref(buildingStore).loading ?? false,
            onEdit: onEditBuilding
          }, null, 8, ["flatten-organizations", "buildings", "total-records", "loading"]),
          _createVNode(BuildingsEdit, {
            modelValue: isModalOpen.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
            "selected-buildings": selectedBuilding.value?.buildings || [],
            "organization-buildings": _unref(buildingStore).organizationBuildings || [],
            "organization-name": selectedBuilding.value?.organization_name || '',
            onAttach: handleAttach,
            onDetach: handleDetach
          }, null, 8, ["modelValue", "selected-buildings", "organization-buildings", "organization-name"])
        ]))
      : _createCommentVNode("", true),
    (isClinician.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(Grades, {
            "flatten-organizations": _unref(flattenOrganizations),
            "user-id": _unref(userId)
          }, null, 8, ["flatten-organizations", "user-id"]),
          (_unref(can)([_unref(PERMISSIONS).CLINICIAN_STUDENTS_INDEX]))
            ? (_openBlock(), _createBlock(ClinicianStudentTable, {
                key: 0,
                "clinician-id": _unref(userId),
                "table-data": _unref(students),
                loading: _unref(loading),
                onUpdate: refreshConnections
              }, null, 8, ["clinician-id", "table-data", "loading"]))
            : _createCommentVNode("", true),
          (_unref(can)([_unref(PERMISSIONS).CLINICIAN_DISCIPLINES_INDEX]))
            ? (_openBlock(), _createBlock(ClinicianDisciplines, {
                key: 1,
                "clinician-id": _unref(userId)
              }, null, 8, ["clinician-id"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isStudent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(Grades, {
            "flatten-organizations": _unref(flattenOrganizations),
            "user-id": _unref(userId)
          }, null, 8, ["flatten-organizations", "user-id"]),
          (_unref(can)([_unref(PERMISSIONS).STUDENT_CLINICIANS_INDEX]))
            ? (_openBlock(), _createBlock(StudentClinicianTable, {
                key: 0,
                "table-data": _unref(clinicians),
                "student-id": _unref(userId),
                loading: _unref(loading),
                onUpdate: refreshConnections
              }, null, 8, ["table-data", "student-id", "loading"]))
            : _createCommentVNode("", true),
          (_unref(can)([_unref(PERMISSIONS).STUDENT_FACILITATORS_INDEX]))
            ? (_openBlock(), _createBlock(StudentFacilitatorTable, {
                key: 1,
                "table-data": _unref(facilitators),
                "student-id": _unref(userId),
                loading: _unref(loading),
                onUpdate: refreshConnections
              }, null, 8, ["table-data", "student-id", "loading"]))
            : _createCommentVNode("", true),
          (_unref(can)([_unref(PERMISSIONS).STUDENT_PARENTS_INDEX]))
            ? (_openBlock(), _createBlock(GuardianTable, {
                key: 2,
                "table-data": _unref(parents),
                "student-id": _unref(userId),
                loading: _unref(loading),
                onUpdate: refreshConnections
              }, null, 8, ["table-data", "student-id", "loading"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})